var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items && _vm.items.length)?_c('v-row',{attrs:{"wrap":""}},_vm._l((_vm.groups),function(group,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"6"}},[_c('StandardChart',{attrs:{"input":group,"chartType":"bar","maxWidth":"100%"}})],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }